import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-scroll';
import { Link as Route } from 'react-router-dom';

const Nav = () => {
  const [fromTop, setFromTop] = useState(0);

  const handleScroll = () => {
    setFromTop(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const navStyle = useMemo(() => {
    return fromTop >= 620 ? styles.fixed : undefined;
  }, [fromTop]);

  return (
    <nav id="nav" style={navStyle}>
      <ul>
        <li>
          <Link to="intro" spy={true} smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li>
          <Route to="business">Aweigh for Business</Route>
        </li>
        <li>
          <Link to="first" spy={true} smooth={true} duration={500}>
            The Aweigh App
          </Link>
        </li>
        <li>
          <Link to="cta" spy={true} smooth={true} duration={500}>
            Privacy
          </Link>
        </li>
        <li>
          <Link to="contact" spy={true} smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );
};

const styles = {
  fixed: {
    position: 'fixed' as 'fixed',
    top: 0,
  },
};

export default Nav;
